import React from 'react';
import { connect } from 'react-redux';
import AppBaseComponent from '../../../../../components/AppBaseComponent';
import { Modal } from 'bootstrap';
import Ax from "../../../../../components/hoc/Ax";
import { toast } from 'react-toastify';
import swal from "sweetalert";
import uuid from 'react-uuid';
import CommonExpenseAddForm from '../../../../accounts/CommonExpenseAddForm';
import HttpAPICall from '../../../../../services/HttpAPICall';
import { IAM_API_BASE_URL_2 } from '../../../../../services/TapApiUrls';

class AssetExpenseData extends AppBaseComponent {
    
    constructor(props) {
        super(props);        
     
         this.expenseDeleteUrl             =   IAM_API_BASE_URL_2 + '/expense/delete';
        this.initState              =   {
            counterlog                  :   null,
            assetData                   :   null,
            shift                       :   null,
            date                        :   '',
            showMoreDetailsForm         :   'N',
            searchedEmployee            :   null,
            searchedVendor              :   null,
            allExpenseHead              :   [],
            AllWalletList               :   [],
            allSections                 :   [],
            allSubSections              :   [],
            permissions                 :   [],
            expenseData                 :   null,
            transaction_id              :   '',
            editExpenseTicketData                  :   null,
            wallet_permission           :   true,
            allPayeeTypes               :   [{value:'vendor',label:'Vendors'},{value:'employee',label:'Employees'},{value:'other',label:'Other'}]
        }
        this.state                  =   {
            access_token                :   '',
            ...this.initState
        }
        this.uploadExpenseModalId      =   uuid();
    }
    
    componentDidMount                   =   ()  =>  {
        this.initalizeComponent(this.props);
        this.uploadExpenseModal        =   new Modal(document.getElementById(this.uploadExpenseModalId), {keyboard: false, backdrop: false}); 
    }
    
    componentWillReceiveProps(nextProps) {
        this.initalizeComponent(nextProps);
    }
    
    initalizeComponent                  =   (pr)  =>  {
        this.setState({access_token : pr.access_token,permissions : pr.permissions});
       
    }
    deleteExpenseInit                      =   (id)  =>  {
        swal({
            title: "Delete",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            dangerMode: true,
            buttons: ["No", "Yes"],
        }).then(willDelete => {
            if (willDelete) {
                HttpAPICall.withAthorization('DELETE', this.expenseDeleteUrl + '/' + id , this.props.access_token, {},{} ,(response) => {
                    toast.success(response.data.msg, {position: toast.POSITION.TOP_RIGHT});
                    if(this.props.afterDeleteExpense) {
                        this.props.afterDeleteExpense()
                    }
                }).then(() => { });
            }
        });
    }
    
    uploadExpenseModalInit             =   (shiftDetail, counterlog, assetData = null,expenseData = null)  =>  {
        this.uploadExpenseModal.show();
                this.setState({
                    assetData           :   assetData,
                    shift               :   shiftDetail,
                    counterlog          :   counterlog,
                    transaction_id      :   counterlog ? counterlog.transaction_id : '',
                    date                :   counterlog ? counterlog.feed_date : '',
                    editExpenseTicketData   :   expenseData, 

                });
   } 

    
   showMoreDetailHandler        =   ()      =>      {
      this.setState({showMoreDetailsForm : "Y"})
   }
    
    uploadExpenseModalJsx              =   ()  =>  {
        return (
            <div className="modal fade" id={this.uploadExpenseModalId} tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="fs-6 m-0">
                                <span>Upload Shift Expense for : </span>{this.state.counterlog ? this.state.counterlog.feed_date_display : null}
                                {this.state.shift ? <span className="ps-2">{this.state.shift.shift_name} ({this.state.shift.shift_start})</span> : null}
                            </h5>
                            <button type="button" className="btn-close"
                            data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className='p-1 bg-light border-bottom'>
                            <table className='table table-sm mb-0 table-borderless text-sm'>
                                <tbody>
                                    <tr>
                                        <td style={{ width: "25%" }}> Asset Name (Code)   </td>
                                        <th>{this.state.assetData ? `${this.state.assetData.name} (${this.state.assetData.asset_code})` : "-"}</th>
                                    </tr>
                                    <tr>
                                        <td>Asset Type </td><th>{this.state.assetData ? `${this.state.assetData.asset_type_name} ` : "-"}</th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-body mx-1">
                            <CommonExpenseAddForm
                                showLogSheetModalData={true}
                                editExpenseTicketData={this.state.editExpenseTicketData}
                                counterlogTransactionId={this.state.transaction_id}
                                expenseForData={{
                                    type: "asset",
                                    asset_id: this.state.assetData?.asset_id,
                                    selected_asset: {
                                        value: this.state.assetData?.asset_id,
                                        label: this.state.assetData?.name,
                                        display_label: `${this.state.assetData?.name} (${this.state.assetData?.asset_code})`,
                                        ...this.state.assetData
                                    }
                                }}
                                onSuccess={() => {
                                    this.uploadExpenseModal.hide();

                                    if (this.props.afterSaveExpense) {
                                        const asset_id = this.state.assetData
                                            ? this.state.assetData.asset_id
                                            : null;

                                        this.props.afterSaveExpense(
                                            this.state.date,
                                            asset_id
                                        );
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render                              =   ()  =>  {
        return (<Ax>
            {this.uploadExpenseModalJsx()}
        </Ax>)
    }
    
}

const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        permissions             :   state.app && state.app.acl_info ? state.app.acl_info : [],
    };
};


export default connect(mapStateToProps, null, null, { forwardRef: true })(AssetExpenseData);

